import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { Costumer } from "../model/costumer";
import { useListCostumers } from "../api/useListCostumers";

interface CostumerAutocompleteSearchBarProps {
  value: Costumer | null;
  onChange: (costumer: Costumer | null) => void;
  disabled?: boolean;
}

const CostumerAutocompleteSearchBar: React.FC<CostumerAutocompleteSearchBarProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { data: costumers, error } = useListCostumers();

  if (!costumers) return <TextField label="Cliente" required fullWidth id="costumerName" autoFocus variant="standard" disabled />;
  if (error) return <p>error</p>;

  return (
    <Autocomplete
      disablePortal
      id="costumer-autocomplete"
      options={costumers}
      getOptionLabel={(option) => option.name}
      value={costumers.find((c) => c.id === value?.id) || null}
      onChange={(e, newValue) => onChange(newValue)}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      disabled={disabled} // Pass disabled to Autocomplete
      renderInput={(params) => (
        <TextField 
          {...params} 
          label="Cliente" 
          required 
          fullWidth 
          id="costumerName" 
          autoFocus={!disabled} // Don't autofocus if disabled
          variant="standard" 
        />
      )}
    />
  );
};

export default CostumerAutocompleteSearchBar;
